/**
 * IP Profile External 服务接口
 * 负责处理跳转到外部 IP Profile 的业务逻辑
 */
export interface IpProfileExternalService {
    /**
     * 处理 IP Profile External 点击事件
     * 会弹出确认对话框，用户确认后跳转到外部地址
     * @returns Promise，用户确认则 resolve，取消则 reject
     */
    handleClick(): Promise<void>;
}

export const IpProfileExternalService = Symbol.for('IpProfileExternalService');
